export const sendGridEventTypes = ["Bounce", "Clicked", "Delivered", "Dropped", "Group Resubscribe", "Group Unsubscribe",
  "Opened", "Spam Report", "Unsubscribe"];
